import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box, Typography, Button, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Dialog,
  DialogTitle, DialogContent, DialogActions, TextField, IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

const API = process.env.REACT_APP_API_URL || '';

const estiloTabla = {
  bgcolor: 'var(--c-superficie)',
  '& .MuiTableCell-root': { color: '#e0e0e0', borderColor: 'var(--c-primario)' }
};
const fieldSx = {
  '& .MuiOutlinedInput-root': {
    color: '#e0e0e0',
    '& fieldset': { borderColor: 'var(--c-primario)' },
    '&:hover fieldset': { borderColor: 'var(--c-acento)' },
  },
};

export default function ObrasSociales() {
  const [lista, setLista] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editando, setEditando] = useState(null);
  const [nombre, setNombre] = useState('');
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, []);

  async function cargar() {
    try {
      const r = await axios.get(`${API}/api/obras-sociales`);
      setLista(r.data);
    } catch (err) { console.error(err); }
  }

  function abrirNuevo() { setEditando(null); setNombre(''); setError(''); setDialogOpen(true); }
  function abrirEditar(os) { setEditando(os.id); setNombre(os.nombre); setError(''); setDialogOpen(true); }

  async function guardar() {
    if (!nombre.trim()) { setError('El nombre es obligatorio'); return; }
    try {
      if (editando) {
        await axios.put(`${API}/api/obras-sociales/${editando}`, { nombre });
      } else {
        await axios.post(`${API}/api/obras-sociales`, { nombre });
      }
      setDialogOpen(false);
      cargar();
    } catch (err) {
      setError(err.response?.data?.error || 'Error al guardar');
    }
  }

  async function eliminar(id) {
    if (!window.confirm('¿Eliminar esta obra social?')) return;
    try {
      await axios.delete(`${API}/api/obras-sociales/${id}`);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al eliminar');
    }
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocalHospitalIcon sx={{ color: 'var(--c-acento)' }} />
          <Typography variant="h5" sx={{ fontWeight: 700, color: 'var(--c-acento)' }}>
            Obras Sociales
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={abrirNuevo}
          sx={{ bgcolor: 'var(--c-primario)', '&:hover': { filter: 'brightness(1.2)' } }}>
          Nueva obra social
        </Button>
      </Box>

      <TableContainer component={Paper} sx={estiloTabla}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: 'var(--c-primario)' }}>
              <TableCell>Nombre</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lista.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ color: '#b0b0b0', py: 4 }}>
                  No hay obras sociales registradas.
                </TableCell>
              </TableRow>
            ) : lista.map(os => (
              <TableRow key={os.id} sx={{ '&:hover': { bgcolor: 'var(--c-primario)' } }}>
                <TableCell sx={{ fontWeight: 500 }}>{os.nombre}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => abrirEditar(os)} sx={{ color: 'var(--c-acento)' }} size="small">
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton onClick={() => eliminar(os.id)} sx={{ color: '#f48fb1' }} size="small">
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}
        PaperProps={{ sx: { bgcolor: 'var(--c-superficie)', color: '#e0e0e0' } }}>
        <DialogTitle sx={{ color: 'var(--c-acento)' }}>
          {editando ? 'Editar obra social' : 'Nueva obra social'}
        </DialogTitle>
        <DialogContent sx={{ mt: 1, minWidth: 340 }}>
          <TextField
            label="Nombre *" fullWidth autoFocus value={nombre}
            onChange={e => { setNombre(e.target.value); setError(''); }}
            onKeyPress={e => e.key === 'Enter' && guardar()}
            InputLabelProps={{ style: { color: 'var(--c-acento)' } }}
            inputProps={{ style: { color: '#e0e0e0' } }}
            sx={fieldSx}
            placeholder='Ej: OSDE, PAMI, Particular...'
          />
          {error && <Typography sx={{ color: '#f44336', fontSize: 13, mt: 1 }}>{error}</Typography>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} sx={{ color: 'var(--c-acento)' }}>Cancelar</Button>
          <Button onClick={guardar} variant="contained"
            sx={{ bgcolor: 'var(--c-primario)', '&:hover': { filter: 'brightness(1.2)' } }}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
